const ChangeRow = ({ label, value }) => {
  if (!value) {
    return null;
  }

  return (
    <div>
      {label}: {value}
    </div>
  );
};

export default ChangeRow;
